import { Record } from 'immutable';

const ThemeRecord = new Record({
	addonKey: null,
	moduleKey: null,
});

export default ThemeRecord;
